import { useRouter } from 'next/router';
import { isTestnet } from '@/shared/featureFlags';

// must stay in sync with scripts/createNginxConfig.mjs, which substitutes this
// placeholder with the request path at serve time
export const CANONICAL_PATH_PLACEHOLDER = '/__CANONICAL_PATH__';

export const useCanonicalUrl = () => {
  const router = useRouter();

  const baseUrl = (
    isTestnet ? process.env.NEXT_PUBLIC_TESTNET_URL : process.env.NEXT_PUBLIC_MAINNET_URL
  ) as string;

  if (!baseUrl) return undefined;

  // during static export, dynamic routes render with the literal route template
  // (e.g. /operators/[id]), so bake a placeholder instead of a broken URL — nginx
  // rewrites it with the real request path when serving the page, and the client
  // re-renders it with the real path after hydration
  const path = router.asPath.includes('[') ? CANONICAL_PATH_PLACEHOLDER : router.asPath;

  return new URL(path, baseUrl).toString();
};
